import { LazyModule, createLazyComponent } from 'owa-bundling';
import { renderCalendarPickerPlaceholder } from './components/CalendarPickerPlaceholder';

export { default as CalendarPickerScenarioId } from './store/schema/CalendarPickerScenarioId';

// Non-Lazy actions
export { unauthorizedCalendarProviderCalendarSelected } from './actions/publicActions';

export {
    getRemoveDeleteConfirmationText,
    shouldShowDelete,
} from './utils/getRemoveDeleteConfirmationText';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarPicker"*/ './lazyIndex')
);

// Lazy component
export const CalendarPicker = createLazyComponent(
    lazyModule,
    m => m.CalendarPicker,
    renderCalendarPickerPlaceholder
);
